import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Form, Input, Row, Select,Pagination,Spin } from 'antd';
import {  AiOutlinePrinter, AiOutlineSearch, AiOutlineSync,AiOutlineRight,AiOutlineDown } from 'react-icons/ai';
import MessageCommon from '../../enum/Message';
import { Label } from 'reactstrap';
import {RequestType,  CartonStatus, ExportType } from '../../enum';
import {  Parameter ,Item ,Option, CartonList, User} from '../../models'
import { Helper, InitHelper,StickyHelper } from '../../helpers';
import { HrWebService,StorageCartonService,PropertyService,WarehouseService, FileManageService} from '../../services';
import dayjs from 'dayjs'
import { EmployeeAutoComplete } from '../../autocomplete/EmployeeAutoComplete'
import { OrgUnitAutoComplete } from '../../autocomplete/OrgUnitAutoComplete';
import Loading from '../../components/Loading';
import secureLocalStorage from 'react-secure-storage';
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

interface AppState {
  currentPage:number
  perpage:number
  total: number
  totalPgae: number
  items:CartonList[]
  isLoading:boolean
}


const ReportTotalCartonList = () => {
    const { instance, accounts } = useMsal();
  const [dataForm] = Form.useForm();
  const { Panel } = Collapse;
  const initialRequestTypeIds:number[] = [
   
    RequestType.StorageCarton, 
  
  ]

  const stickyHelper = new StickyHelper('total-carton-list',50,50)
  stickyHelper.setMinHight(900)
  const stickyElement = stickyHelper.getElement()
  const userStore = secureLocalStorage.getItem('user')
  const user:User = userStore ? JSON.parse(userStore.toString()): null
  const pageSizeOptions = user.systemConfig.tablePageSize
  const [requestTypeIds,setRequestTypeIds] = useState<number[]>(initialRequestTypeIds)
  const [documentStartYear, setDocumentStartYear] = useState<number|null|undefined>(undefined);
  const [documentEndYear, setDocumentEndYear] = useState<number|null|undefined>(undefined);
  const [warehouseOptions, setWarehouseOptions] = useState<Option[]>([])
  const [saveParamter,setSaveParameter] = useState(InitHelper.InitialParameter())
  const [width,setWidth] = useState(0)
  const [isPrint,setIsprint] = useState(true)
  const [appState,setAppState] = useState<AppState>({
    currentPage : 1,
    total : 0,
    totalPgae : 0,
    perpage: 10,
    items: [],
    isLoading : true
  })
  const [requesters, setRequesters] = useState<Item[]>([])
  const [owners, setOwners] = useState<Item[]>([])
  const [orgunits, setOrgUnits] = useState<Item[]>([])
  const [warehouse, setWarehouse] = useState("")
  const [active, setActive] = useState(-1)
  const [isLoadingPrint,setIsLoadingPrint] = useState(false)
  const [activeKey,setActiveKey] = useState('0')
  const onFinish = (values: any) => {
  };
  const [clientHeight,setClientHeight] = useState(0)

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
 
  const getData = async (currentPage: number,perpage: number,_parameter:Parameter | null = null,print:boolean = true) => {
    let _state:AppState = Object.assign({},appState)
       _state.isLoading = true
       setAppState(_state)
    let parameter = Object.assign({},saveParamter)
    if(_parameter !== null){
        parameter = Object.assign({},_parameter);
    }

    parameter.statusIds = [CartonStatus.Done]
      parameter.page = currentPage
      parameter.limit = perpage
      parameter.orderBy = "status"
      parameter.totalCarton = 1
    
      console.log(parameter)
      let token = await getToken()
      try{
          let result = await new StorageCartonService(token).SearchCarton_withGroupByCarton(parameter)
        console.log(result)
        if(result && result.success)
        {
          let state = Object.assign({},appState)
          state.total = result.data.total
          state.currentPage = currentPage
          state.perpage = perpage
          state.items = result.data.items
          state.isLoading = false

        if(result.data.total>0 && print){
          setIsprint(false)
        }else{
          setIsprint(true)
        }
         // setTimeout(() => {
            setSaveParameter(parameter)
            setAppState(state)
            setTimeout(() => {
              onSetClientHeight()
            }, 300);
          //}, 500);
        }
        else{
          let state = Object.assign({},appState)
          state.isLoading = false
          setAppState(state)
        }
      }
      catch(error)
      {
        console.log(error)
        let state = Object.assign({},appState)
          state.isLoading = false
          setAppState(state)
      }
      
      

  }

  const onRequesterSelect = (item:any) => {
    setRequesters(item)
    stickyHelper.updatePosition()
  }
  
  const onOwnerSelect = (item:any) => {
    setOwners(item)
    stickyHelper.updatePosition()
  }

  const onOrgUnitSelect = (item:any) => {
    setOrgUnits(item)
    stickyHelper.updatePosition()
  }
  
  const onSearchEmployee = async(key:string) => {
   
      let token = await getToken()
      let result = await new HrWebService(token).SearchEmployee2(key)
      if(result && result.success)
      {
        return result.data
      }
      else{
        console.log(result?.message)
        return []
      }
  }

  const onSearchOrgUnit = async(key:string) => {
   
    let token = await getToken()
    let result = await new PropertyService(token).GetOrgUnits(key)
    if(result && result.success)
    {
      return result.data
    }
    else{
      console.log(result?.message)
      return []
    }
}

    const getWarehouses = async () => {
        let token = await getToken()
        let result = await new WarehouseService(token).GetAllWarehouses()
    if(result && result.success){
        let options:Option[] = [{ label:'All' , value: "" }]
        let Locationoptions:Option[] = result.data.map((item) => { return { value: item.warehouseName, label: item.warehouseName  }})
        setWarehouseOptions(options.concat(Locationoptions))
    }
  }

  const onSetClientHeight = () => {
    
    setTimeout(() => {
      stickyHelper.updatePosition()
      window.scrollTo(0,0)
      let element = document.getElementById(stickyElement.container) as HTMLInputElement
      if(element){
        let value = element.clientHeight
        setClientHeight(value)
      }
    }, 100);
  
  }

  useEffect(() => {
    
      setRequestTypeIds(initialRequestTypeIds)
    getWarehouses()
    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.cartonStatusIds = [CartonStatus.Storage]

 
    getData(1,appState.perpage,parameter,false).then(() => {
      stickyHelper.updatePosition()
  
    })
   
    stickyHelper.removeEvent()
    stickyHelper.addEvent()
    window.addEventListener("resize", () => { 
      onSetClientHeight()
  });
  }, [])

    const getToken = async () => {
        const acc = accounts && accounts.length ? accounts[0] : null;
        apiRequest.scopes[0] = "api://" + secureLocalStorage.getItem('clientId') + "/read_user_profile"
        if (acc) {
            const { accessToken: token } = await instance.acquireTokenSilent({
                account: acc,
                scopes: apiRequest.scopes
            });
            return token;
        }
        return ""
    }


  const onPageChange = (page:number,perpage:number) => {
    
    if(perpage !== appState.perpage){
        getData(1,perpage)
    }
    else{
      getData(page,appState.perpage)
    }
  }

    const fieldParameterMap = (field: any, parameter: any) => {
        if (field.cartonStatusIds) {
            parameter.cartonStatusIds = field.cartonStatusIds
        }

        if (field.requestNo) {
            parameter.requestNoList = field.requestNo.trim().split(',')
        }

        if (field.cartonNoList) {
            parameter.cartonNo = field.cartonNoList.trim()
        }

        if (field.cartonNo) {
            parameter.cartonNo = field.cartonNo.trim()
        }
    }
  const searchData = async () => {
   
    let field = dataForm.getFieldsValue()
   
      let parameter = InitHelper.InitialParameter();
      parameter.cartonStatusIds = [CartonStatus.Storage, CartonStatus.Collect, CartonStatus.Return,CartonStatus.Remove, CartonStatus.Destruction]
      fieldParameterMap(field, parameter)
        
        parameter.requestTypeIds = requestTypeIds
        parameter.cartonLocation = warehouse
          if (active === 1) {
              parameter.cartonStatusIds = [CartonStatus.Storage, CartonStatus.Collect, CartonStatus.Return]
          }
          if (active === 0) {
              parameter.cartonStatusIds = [CartonStatus.Remove, CartonStatus.Destruction]
          }
      
    if(documentStartYear && documentStartYear > 0 && documentEndYear && documentEndYear > 0)
    {
        parameter.requestStartDate = documentStartYear + "-01-01"
        parameter.requestEndDate = documentEndYear + "-12-31"
    }

    if(requesters.length > 0){
      parameter.requesters = requesters.map(item => item.key)
    }
    
    if(owners.length > 0){
      parameter.owners = owners.map(item => item.key)
    }

    if(orgunits.length > 0){
      parameter.orgUnits = orgunits.map(item => item.key)
    }

    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
    let cartonNoStart = ""
    let cartonNoEnd = ""
    if(elementStart){
      cartonNoStart = elementStart.value
    }
    if(elementEnd){
      cartonNoEnd = elementEnd.value
    }

    if(cartonNoStart && cartonNoEnd){
        parameter.cartonNo = cartonNoStart.trim() + '&' + cartonNoEnd.trim()
    }

    console.log(parameter)
    getData(1,appState.perpage,parameter,true)
    
  }
  const reset = () => {
    setIsprint(true)
    dataForm.resetFields()
    setOwners([])
    setOrgUnits([])
    setRequesters([])
    setDocumentStartYear(undefined)
    setDocumentEndYear(undefined)
    setWarehouse("")
    setActive(-1)
    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.warehouseId = 0
    parameter.cartonStatusIds = [CartonStatus.Storage, CartonStatus.Collect, CartonStatus.Return,CartonStatus.Remove, CartonStatus.Destruction]

    getData(1,appState.perpage,parameter,false).then(() => {
      stickyHelper.updatePosition()
  
    })
  }

  const onDocumentStartYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentStartYear(year)
  }
  
  const onDocumentEndYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentEndYear(year)
  }

  const onFinishPrint = async () => {
    setIsLoadingPrint(true)
    let token = await getToken()
    try{
      await new FileManageService(token).DownloadReport(saveParamter,ExportType.TOTAL_CARTON_LIST);
    }catch(error){
      console.log("🚀 ~ file: ReportTotalCartonList.tsx:378 ~ onFinishPrint ~ error:", error)
    }finally{
      setIsLoadingPrint(false)
    }
  }

  const onCartonActiveChange = (value:number) => {
     setActive(value)
  }

  const onWarehouseChange = (value:string) => {
    setWarehouse(value)
}
  
const collapseChange = () => {
  let key = activeKey === "1" ? "0" : "1"
  setActiveKey(key)
  let element = document.getElementById("open-search") as HTMLInputElement
  element.value = key
  stickyHelper.updatePosition()
}
  return (

    <div>
       <div id={stickyElement.search} className='carton-search-top' onClick={ () => stickyHelper.setCollapse()}>
          <span id="arrow-right" className='display-inline'>
              <AiOutlineRight className='carton-search-top-img'/>
          </span>
          <span id="arrow-down" className='display-none'>
            <AiOutlineDown  className='carton-search-top-img'/>
          </span>
          <span>Search</span>
            
        </div>
        <div id={stickyElement.openSearch} className='carton-search-bottom' >
        {isLoadingPrint?<Loading/>:<></>}
        <Form
            {...layout}
            form={dataForm}
            name="nest-messages"
            onFinish={onFinish}
            validateMessages={validateMessages}
            labelAlign="left"
            colon={false}
            labelWrap={true}
          >
            <Row>
              <Col md={11} >
                <Form.Item name="carton_status" label="Carton Status"  >
                  <Select placeholder={MessageCommon.TitleSelect} defaultValue={-1}
                    onChange={onCartonActiveChange}
                    options={[
                      { value: -1, label: 'All' },
                      { value: 1, label: 'Active Carton' },
                      { value: 0, label: 'Inactive Carton' },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
              <Form.Item name="cartonStatusIds" label="Carton Status"   >
                  <Select 
                    key={Helper.Uniqid()}
                    disabled={active !== -1}
                    placeholder={MessageCommon.TitleSelect} 
                    mode="multiple"
                    allowClear
                    options={[
                      { value: CartonStatus.Storage, label: 'Storage' },
                      { value: CartonStatus.Collect, label: "Collect" },
                      { value: CartonStatus.Return, label: "Return" },
                      { value: CartonStatus.Remove, label: 'Remove' },
                      { value: CartonStatus.Destruction, label: 'Destroy' }
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="requestNo" label="Request No."  >
                      <Input placeholder="ex. A230001" />
                    </Form.Item>

              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
              <Form.Item name="documentyear" label="Year">
                  <table className='w100c'>
                    <tr>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' 
                          className='w100c' 
                          onChange={onDocumentStartYearChange}
                        />
                      </td>
                      <td>
                        <Label className='margin-left10 margin-right10 vertical-align-top'>To</Label>
                      </td>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' 
                          className='w100c'
                          onChange={onDocumentEndYearChange}
                        />
                      </td>
                    </tr>
                  </table>


                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
              <Form.Item name="cartonLocation" label="Carton Location"  initialValue={""}>
                    <Select 
                        showSearch
                        onChange={onWarehouseChange}
                        placeholder="Please select..." 
                        options={warehouseOptions} 
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                 </Form.Item>
             

              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
              <Form.Item name="orgUnit" label="Org. Unit"  >
                        <OrgUnitAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={orgunits ? orgunits : []}
                            onChange={item => onOrgUnitSelect(item)}
                            service={onSearchOrgUnit}
                            minimumTextLength={2}
                        />
                    </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col md={11} >
              <Form.Item name="owner" label="Owner"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={owners ? owners : []}
                            onChange={item => onOwnerSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                    </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
              <Form.Item name="requester" label="Requester"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={requesters ? requesters : []}
                            onChange={item => onRequesterSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                  </Form.Item>
              </Col>
            </Row>

           
          </Form>
          <div className='text-center'>
            <Button type="default" className='mr-btn' onClick={reset} >
              <AiOutlineSync className='icn-btn' /> Reset
            </Button>
            <Button type="primary" onClick={searchData}  >
              <AiOutlineSearch className='icn-btn' /> Search
            </Button>


          </div>
        </div>
      
        <div id={stickyElement.space} className='sticky-space sticky-bg-white display-none'></div>
        <div id={stickyElement.space2} className='sticky-space2 sticky-bg-grey'></div>

        <div id={stickyElement.result}  className='sticky-data-top sticky-border-top sticky-border-left sticky-border-right'>
            
                      <div>
                          <Button type="primary" htmlType="button" className='mr-btn' disabled={isPrint} onClick={() => onFinishPrint()}>
                              <AiOutlinePrinter className='icn-btn' />Print
                          </Button>
                      </div>
                   
                        <div className='search-result'>Search found {appState.total} record(s).</div>
                          
                


        </div>

        <div id={stickyElement.dataFixed} className='sticky-data-bottom sticky-border-bottom sticky-border-left sticky-border-right'>
        <div id={stickyElement.container}>
        { appState.isLoading ?
            <div className='margin-auto padding-bottom-30'>
              <Spin tip="Loading" size="large">
                <div className="content" />
              </Spin>
            </div>
          :
        
          <table className='idoc-table'>
            <thead id={stickyElement.data}>
              <tr>
                <th className="thfix1 text-center w50 font075em">No.</th>
                <th className="s-th thfix2 font075em">Carton No.</th>
                <th className="s-th font075em">
                  <div>Carton</div>
                  <div>Location</div>
                </th>
                <th className="s-th font075em">Request No.</th>
                <th className="s-th font075em">Request Date</th>
                <th className="s-th font075em">Document Year</th>
                <th className="s-th font075em">Requester</th>
                <th className="s-th font075em">Owner</th>
                <th className="s-th font075em">Org. Unit</th>
                <th className="s-th font075em">Collect Date</th>
                <th className="s-th font075em">Return Date</th>
                <th className="s-th font075em">Carton Status</th>
              </tr>
            </thead>
           
            <tbody >
            { appState.items.map((item:CartonList,index) => (
                <tr>
                  <td className="tdfix1 text-center w50 font08em">{((appState.currentPage -1) * appState.perpage) + index + 1} </td>
                  
                    <td className={(item.cartonStatusId === CartonStatus.Remove || item.cartonStatusId === CartonStatus.Destruction) ? 's-td tdfix2 text-center font08em c-red' : 's-td tdfix2 text-center font08em ' }>{item.cartonNo}</td>
                  <td className="s-td text-left break-word font08em">{item.cartonLocation}</td>
                  <td className="s-td text-center font08em">{item.requestNo}</td>
                  <td className="s-td text-center font08em">{ dayjs(item.requestDate).format('DD MMM YYYY') }</td>
                  
                  <td className="s-td text-center font08em">{ dayjs(item.documentYear).format('MMM YYYY')}</td>
                  <td className="s-td text-left break-word font08em">{item.requesterName}</td>
                  <td className="s-td text-left break-word font08em">{item.ownerName}</td>
                  <td className="s-td text-center font08em">{item.orgUnit}</td>
                  <td className="s-td text-center font08em">
                        {item.collectRequestDate ? dayjs(item.collectRequestDate).format('DD MMM YYYY') : ""}
                  </td>
                  <td className="s-td text-center font08em">
                    { item.returnDate ? dayjs(item.returnDate).format('DD MMM YYYY') : ""}
                  </td>
                 
                  <td className="s-td text-center font08em">{item.cartonStatus !== 'Destruction' ? item.cartonStatus : 'Destroy'}</td>
                 
                </tr>
              ))
            }
            
            </tbody>
  
          </table>
        }
        </div>
        <div className='margin-top-10 text-right'>
        { appState.total > 0 ?
           <Pagination 
           key={Helper.Uniqid()}
           current={appState.currentPage} 
           pageSize={appState.perpage}
           total={appState.total} 
           showSizeChanger={true} 
           pageSizeOptions={pageSizeOptions}
           onChange={onPageChange} 
         />:<></>
        }
        </div>
        </div>
       
        <input type="hidden" id={stickyElement.clientHight} defaultValue={clientHeight}/>
        
    </div>
  );

}

export default ReportTotalCartonList
